import { message } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import Modal from '../../../components/Modal/Modal';

import { TRootState } from '../../../store/store';
import { transport } from '../../../utils/constants';
import { getToken } from '../../../utils/helper';
import { getPositions } from '../helper';
import { ProductClient } from '../../../generated/mlmbox/client/product/product.client';
import { Invoice_PreviewResponse_Item } from '../../../generated/mlmbox/types/product';
import Button from '../../../components/Button/Button';

export const Reserv: React.FC<{ treeId: number }> = ({ treeId }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [binar, setBinar] = useState(false);
    const [value, setValue] = useState(0);
    const [positions, setPositions] = useState('');
    const [valueBinar, setValueBinar] = useState(0);
    const [isReady, setIsReady] = useState(false);
    const [areas, setAreas] = useState('');
    const [quantity, setQuantity] = useState(1);
    const wallet = useSelector((state: TRootState) => state.wallet.value);

    const [book, setBook] = useState(0);
    const matrixTreeAccountsList = useSelector((state: TRootState) => state.user.value.treeAccounts);

    useEffect(() => {
        if (!matrixTreeAccountsList.length) return;

        const result = matrixTreeAccountsList.find((el) => el.treeId === treeId);

        if (result) setBook(result.bookingQuantity);
        else setBook(0);
    }, [matrixTreeAccountsList, treeId]);

    function getDelta(list: Invoice_PreviewResponse_Item[]): void {
        if (list.length <= 2) setAreas('P1');
        if (list.length > 2) setAreas(`P1-P${list.length - 1}`);
        setBinar(true);
    }

    function reserv(id: number): void {
        const binarMatrix = matrixTreeAccountsList.find((el) => el.treeId === 16);
        if (!binarMatrix) return;
        const binars = binarMatrix?.bookingQuantity > 0 || binarMatrix?.entities.length > 0;

        const matrixClient = new ProductClient(transport);

        isReady
            ? matrixClient
                  .verifiedPurchase(
                      {
                          entities: !binars
                              ? [
                                    {
                                        quantity: quantity,
                                        treeId: id,
                                    },
                                    {
                                        quantity: quantity,
                                        treeId: 16,
                                    },
                                ]
                              : [
                                    {
                                        quantity: quantity,
                                        treeId: id,
                                    },
                                ],
                      },
                      { meta: { authorization: getToken() } }
                  )
                  .then(({ status }) => {
                      if (status.code === 'OK') {
                          setIsReady(false);
                          message.success('Площадка активирована');
                          window.location.reload();
                      }
                  })
                  .finally(() => setIsReady(false))
            : matrixClient
                  .previewPurchase(
                      {
                          entities: !binars
                              ? [
                                    {
                                        quantity: quantity,
                                        treeId: id,
                                    },
                                    {
                                        quantity: quantity,
                                        treeId: 16,
                                    },
                                ]
                              : [
                                    {
                                        quantity: quantity,
                                        treeId: id,
                                    },
                                ],
                      },
                      { meta: { authorization: getToken() } }
                  )
                  .then(({ status, response }) => {
                      if (status.code === 'OK') {
                          setPositions(getPositions(response.items));
                          if (!binar && !binars) {
                              setQuantity(1);
                              setValueBinar(Number(response.billAmounts[0].value) - 25);

                              getDelta(response.items);
                              setBinar(true);
                          } else if (Number(response.billAmounts[0].value) > Number(wallet.assets[0].assetBalance)) {
                              setValue(Number(response.billAmounts[0].value) - Number(wallet.assets[0].assetBalance));
                              window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
                              setIsOpen(true);
                          } else {
                              setValue(Number(response.billAmounts[0].value));
                              setIsReady(true);
                          }
                      }
                  });
    }
    const navigate = useNavigate();

    return (
        <div className="reserv">
            {book > 0 ? (
                <h1>{t('matrix.reserv.book')}</h1>
            ) : (
                <>
                    <h1>{t('matrix.reserv.title')}</h1>

                    <Button
                        title={t('matrix.reserv.btn')}
                        onClick={() => reserv(treeId)}
                    />
                </>
            )}

            {binar && (
                <Modal
                    closeBtn={() => {
                        setQuantity(1);
                        setBinar(false);
                    }}>
                    <div className="show binar">
                        <h1>{t('binar_book_title')}</h1>
                        <p>{t('binar_book_description')}</p>
                        <div className="binar__select">
                            <p>{t('select_binar_book_title')}</p>
                            <div className="btns">
                                <button
                                    className={quantity === 1 ? 'active' : ''}
                                    onClick={() => setQuantity(1)}>
                                    x1
                                </button>
                                <button
                                    className={quantity === 3 ? 'active' : ''}
                                    onClick={() => setQuantity(3)}>
                                    x3
                                </button>
                                <button
                                    className={quantity === 7 ? 'active' : ''}
                                    onClick={() => setQuantity(7)}>
                                    x7
                                </button>
                            </div>
                        </div>

                        <div className="binar__check">
                            <h2>
                                {t('binar_check_1', { area: areas })}
                                <span>{valueBinar.toLocaleString()}$</span>
                            </h2>
                            <h2>
                                {t('binar_check_2', { x: `x${quantity}` })}
                                <span>{(quantity * 25).toLocaleString()}$</span>
                            </h2>
                            <div className="line"></div>
                            <h2>
                                {t('binar_book_result')} <span>{(valueBinar + quantity * 25).toLocaleString()}$</span>
                            </h2>
                        </div>
                        <div className="btns">
                            <Button
                                title={t('btns.cancel')}
                                onClick={() => {
                                    setQuantity(1);
                                    setBinar(false);
                                }}
                            />
                            <Button
                                title={t('matrix.reserv.btn')}
                                onClick={() => {
                                    setValue(valueBinar + quantity * 25);
                                    reserv(treeId);
                                }}
                            />
                        </div>
                    </div>
                </Modal>
            )}

            {isOpen && (
                <Modal closeBtn={() => setIsOpen(false)}>
                    <div className="show">
                        <h1>{t('matrix.reserv.modals.not_money.title')}</h1>
                        <p>{t('matrix.reserv.modals.not_money.text', { amount: value.toLocaleString() })}</p>
                        <Button
                            title={t('matrix.reserv.modals.not_money.btn')}
                            onClick={() => navigate('/wallet?deposit=true')}
                        />
                    </div>
                </Modal>
            )}
            {isReady && (
                <Modal closeBtn={() => setIsReady(false)}>
                    <div className="show">
                        <h1>{t('matrix.reserv.modals.ready.title')}</h1>
                        <p>{t('matrix.reserv.modals.ready.text', { amount: value.toLocaleString(), positions })}</p>
                        <Button
                            title={t('matrix.reserv.modals.ready.btn')}
                            onClick={() => reserv(treeId)}
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};
